import { useMemo } from "react";
import * as React from "react";
import styled from "styled-components";
import { Select, Icon } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
const StyledIcon = styled(Icon)`
  width: 24px;
  vertical-align: middle;
`;
const renderOption = (option) => option.value.type === "stream" ? /* @__PURE__ */ React.createElement(React.Fragment, null, option.label) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledIcon, { name: "stacks", size: "xs" }), option.label);
const StreamsAndCategoriesFilter = ({
  id,
  onChange,
  streams,
  value = void 0,
  streamCategories = void 0,
  required = true,
  showStreams = true,
  showCategories = true,
  grouping = true,
  multi = true,
  ...rest
}) => {
  const options = useMemo(() => {
    const sortedCategories = showCategories && multi ? [...new Set(streams.flatMap((stream) => {
      var _a;
      return (_a = streamCategories != null ? streamCategories : stream == null ? void 0 : stream.categories) != null ? _a : [];
    }))].map((category) => ({
      label: category,
      value: { id: category, type: "category" }
    })).sort((a, b) => defaultCompare(a.label, b.label)) : [];
    const sortedStreams = showStreams ? streams.map((stream) => ({
      label: stream.title,
      value: { id: stream.id, type: "stream" }
    })).sort((a, b) => defaultCompare(a.label, b.label)) : [];
    return grouping ? [...sortedCategories, ...sortedStreams] : [...sortedCategories, ...sortedStreams].sort(
      (a, b) => defaultCompare(a.label, b.label)
    );
  }, [grouping, multi, showCategories, showStreams, streams, streamCategories]);
  if (!options || options.length === 0) return null;
  const selectedOptions = options.filter(
    (o) => {
      var _a, _b;
      return o.value.type === "stream" && ((_a = value == null ? void 0 : value.streams) == null ? void 0 : _a.includes(o.value.id)) || o.value.type === "category" && ((_b = value == null ? void 0 : value.categories) == null ? void 0 : _b.includes(o.value.id));
    }
  );
  const handleReactSelectChange = (selected) => {
    const selectedArray = Array.isArray(selected) ? selected : selected ? [selected] : [];
    onChange({
      streams: selectedArray.filter((o) => o.value.type === "stream").map((o) => o.value.id),
      categories: selectedArray.filter((o) => o.value.type === "category").map((o) => o.value.id)
    });
  };
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      ...rest,
      id,
      onChange: () => {
      },
      onReactSelectChange: handleReactSelectChange,
      options,
      optionRenderer: renderOption,
      valueRenderer: renderOption,
      value: selectedOptions,
      required,
      multi
    }
  );
};
export default StreamsAndCategoriesFilter;
